import { render, staticRenderFns } from "./BlogbookCatalogRestore.vue?vue&type=template&id=3eb089f8&scoped=true&"
import script from "./BlogbookCatalogRestore.vue?vue&type=script&lang=js&"
export * from "./BlogbookCatalogRestore.vue?vue&type=script&lang=js&"
import style0 from "./BlogbookCatalogRestore.vue?vue&type=style&index=0&id=3eb089f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb089f8",
  null
  
)

export default component.exports